
import { defineComponent } from "vue";

import EnrollmentContent from "./components/EnrollmentContent.vue";

export default defineComponent({
  name: "EnrollmentPage",
  components: {
    EnrollmentContent
  },
});
